import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { Field, reduxForm } from 'redux-form';
import Text from '../../common/components/inputs/Text';
import SelectConstant from 'FDComponents/constants/Select';
import ImageInput from "../images/Input";

const styles = theme => ({
  body: {
    borderLeft: `3px solid ${theme.palette.primary[500]}`,
  },
});

@withStyles(styles)
@reduxForm({
  form: 'partner_form',
  validate: values => {
    const errors = {};
    if (!values.name) {
      errors.name = 'error_required';
    }
    if (!values.sector) {
      errors.sector = 'error_required';
    }
    if (!values.logo) {
      errors.logo = 'error_required';
    }
    return errors;
  },
})
@injectIntl
export default class PartnerDialog extends Component {
  state = {
    open: false,
  };

  handleOpen = () => {
    this.setState({ open: true });
  };
  handleClose = () => {
    this.setState({ open: false });
    this.props.reset();
  };
  handleConfirm = partner => {
    this.handleClose();
    this.props.onCreate(partner);
  };

  render() {
    const {
      title,
      handleSubmit,
      pristine,
      submitting,
      classes,
      children,
      intl: { messages: m },
      disabled,
      valid,
    } = this.props;
    const { open } = this.state;

    return (
      <div>
        {React.cloneElement(children, { onClick: this.handleOpen, key: 'open_button', disabled })}
        <Dialog open={open} classes={{ paper: classes.body }}>
          <DialogTitle>{title}</DialogTitle>
          <form onSubmit={handleSubmit(this.handleConfirm)}>
            <DialogContent>
              <Field name="name" component={Text} label={m.field_name} autoFocus required />
              <Field name="sector" component={SelectConstant} label={m.field_sector} entity={'partner'} required />
              <Field name="logo" component={ImageInput} label={m.field_logo} entity={'image'} required />
            </DialogContent>
            <DialogActions>
              <Button color="primary" onClick={this.handleClose} disabled={submitting}>
                {m.button_cancel}
              </Button>
              <Button color="primary" variant="contained" type="submit" disabled={!valid || pristine || submitting}>
                {m.button_create}
              </Button>
            </DialogActions>
          </form>
        </Dialog>
      </div>
    );
  }
}
